//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import React from 'react';

import { MediaLibrarySourcesDropdownItemData } from '@media-library/components/top-bar/sources-dropdown/mediaLibrarySourcesDropdownConstants';
import { SourcesModal } from '@media-library/components/top-bar/sources-modals/SourcesModal';
import { MediaLibraryTrackingIds } from '@media-library/constants/mediaLibraryTrackingIds';

interface AllTrackedUsersModalProps {
  handleChangeSelects: (
    updatedSources: MediaLibrarySourcesDropdownItemData,
  ) => void;
  handleCloseModal: () => void;
  isOpen: boolean;
  trackedUsers: MediaLibrarySourcesDropdownItemData;
}

export const AllTrackedUsersModal = ({
  handleChangeSelects,
  handleCloseModal,
  isOpen,
  trackedUsers,
}: AllTrackedUsersModalProps) => {
  return (
    <SourcesModal
      applyButtonTrackingId={
        MediaLibraryTrackingIds.APPLY_ALL_TRACKED_USERS_MODAL
      }
      cancelButtonTrackingId={
        MediaLibraryTrackingIds.CLOSE_ALL_TRACKED_USERS_MODAL
      }
      handleChangeSelects={handleChangeSelects}
      handleCloseModal={handleCloseModal}
      isOpen={isOpen}
      searchBarPlaceholder='Search usernames'
      searchBarTrackingIdPrefix={
        MediaLibraryTrackingIds.ALL_TRACKED_USERS_MODAL_SEARCH_BAR
      }
      searchBarVisuallyHiddenLabel='Search usernames'
      sourcesGroup={trackedUsers}
      tertiaryButtonInfo={{
        content: 'Manage Tracked Users',
        state: 'library.tracked-sources.user',
        trackingId:
          MediaLibraryTrackingIds.ALL_TRACKED_USERS_MODAL_MANAGE_TRACKED_USERS_LINK,
      }}
      title='All Tracked Users'
    />
  );
};
